export default "__VITE_ASSET__D7EKivM3__"